import React, { useEffect } from "react";
import { useStateContext } from "@/components/state";

const usePagesAbstract = ({ pages, submit }) => {
    const context = useStateContext();
    const { state, dispatch } = context;

    const next = (e) => {
        e.preventDefault();
        let value = state.scenes.current;
        value = value + 1 > state.scenes.total ? value : value + 1;

        if (state.scenes.total === state.scenes.current) {
            submit?.();
        } else {
            window.scrollTo({ top: 0 });
            dispatch({ scenes: { current: value }});
        }
    }

    useEffect(() => {
        if (!pages || pages?.length === 0) return;
        dispatch({
            scenes: {
                current: state?.scenes?.current ?? 1,
                total: pages.length,
            },
            conditions: { // TODO remove
                locked: false,
                submitted: false,
            },
        });
    }, [pages])

    return {
        next,
    }
};

export default usePagesAbstract;
